// 9fbef606107a605d69c0edbcd8029e5d
import { PropTypes } from 'prop-types';
import React from 'react';
import LabeledRadioButton from '@tcp/core/src/components/common/molecules/LabeledRadioButton';
import cssClassName from '@tcp/core/src/utils/cssClassName';
import withStyles from '../../../hoc/withStyles';
import style from '../styles/RatingPills.style';
import { Ratings } from '../../../../features/browse/PlpTile/views/styles/ReviewRatings.style';

import Button from '../../Button';

const RatingPills = (props) => {
  const {
    className,
    optionsMap,
    formValues,
    setSelectedFilterName,
    placeholder,
    ratingLabel,
    outOfLabel,
    handleItemClick,
    item,
    index,
    getRatingFromString,
    isTileRedesignAB,
  } = props;
  return (
    <div className={`${className} ratings-wrapper`}>
      <Button
        className="pill-click ratings"
        onClick={(e) => {
          e.preventDefault();
          setTimeout(() => {
            setSelectedFilterName(placeholder);
            handleItemClick(e, index);
          }, 0);
        }}
      >
        <LabeledRadioButton
          key={item.value}
          id={index}
          name={item.value}
          value={item?.value}
          checked={formValues?.TCPBazaarVoiceRating_inText_uFilter?.includes(item?.value)}
          selectedValue={item.value}
          tabIndex="0"
          input={formValues[optionsMap[index]?.name]?.includes(item?.value)}
          disabled={item.disabled}
          newQVDesign={true}
          isNewPDPEnabled={true}
          isPLPFilterRedesign={true}
          className={cssClassName(
            `${className}-item `,
            className,
            { ' item-selected-option': item.value === item.name },
            { ' item-disabled-option': item.disabled }
          )}
        >
          {' '}
        </LabeledRadioButton>
        <Ratings
          className="rating-filter"
          aria-label={`${ratingLabel} ${getRatingFromString(item.title)?.first} ${outOfLabel} 5`}
          title={`${ratingLabel} ${getRatingFromString(item.title)?.first}`}
          value={getRatingFromString(item.title)?.first}
          isTileRedesignAB={isTileRedesignAB}
        />

        <div className="post-rating-text">{getRatingFromString(item.title)?.second}</div>
      </Button>
    </div>
  );
};

RatingPills.propTypes = {
  className: PropTypes.string.isRequired,
  optionsMap: PropTypes.shape([]),
  input: PropTypes.shape({ value: {}, onChange: () => {} }),
  isLoadingMore: PropTypes.bool,
  formValues: PropTypes.shape({}),
  allowMultipleSelections: PropTypes.bool,
  onFilterSelection: PropTypes.func,
  isFavoriteView: PropTypes.bool,
  placeholder: PropTypes.string,
  setSelectedFilterName: PropTypes.func,
};

RatingPills.defaultProps = {
  optionsMap: [],
  input: {},
  isLoadingMore: false,
  formValues: {},
  allowMultipleSelections: false,
  onFilterSelection: () => {},
  isFavoriteView: false,
  placeholder: '',
  setSelectedFilterName: () => {},
};

export default withStyles(RatingPills, style);
export { RatingPills as RatingPillsVanilla };
